
import { saveRedirectInfoToLocalStorage } from '@/utils/auth';
import { useEffect } from 'react';

export const RedirectInfoProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  useEffect(() => {
    saveRedirectInfoToLocalStorage();
  }, []);

  return <>{children}</>;
};
